import React from 'react'
export default function Hero() {

  return (
    <>
    <div className="h-h-half w-full bg-alpha relative">
        <div className={`w-1/2  h-full absolute left-0 top-0 bg-hero bg-no-repeat bg-[100% 100%]`}></div>
        <div className="flex h-full items-center justify-center relative z-10">
            <h1 className="font-bold text-title-xxl">Deep Fake Arabic Audio Detection</h1>
        </div> 
    </div>
    <div className="py-5 bg-primary"></div>
    </>
  )
}
